import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({
    name: 'distanceFromNow'
})
export class DistanceFromNowPipe implements PipeTransform {
    transform(dateToCompareToNow?: string | number): string {
        return formatDistance(dateToCompareToNow ? new Date(dateToCompareToNow) : new Date(), new Date(), { addSuffix: true });
    }
}
